import { ApartmentOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import React from 'react';
import StreamingOff from '../assets/icons/live-streaming-off.svg';
import StreamingOn from '../assets/icons/live-streaming-on.svg';
import * as ACTION from '../constants/action.types';
import * as SYSTEM from '../constants/system.keys';
import { minutesToTime, secondsToTime } from '../helpers/formatTime';
import { getDiffTimeFromNow } from '../untils/date';
import storageService from '../services/storage.service';
import CryptoJS from 'crypto-js';
import {
  DETECT_FIRE,
  DETECT_WEAPON,
  RECOGNITION_FACE,
} from '../constants/action.types';
import * as SERVICE from '../constants/service.types';
import { composeReducers } from '../untils/redux';
import { liveReducer } from './live/reducer';
import { beeXLogger } from '../helpers/logger';
import { recoveryReducer } from './recovery/reducer';

const initialState = {
  streams: [],
  socketState: 0,
  // khởi tạo là 0, connect=1 disconnect=-1
  isAuth: 0,
  // khởi tạo là 0, login =1 logout =-1
  notifications: [],
  mapsNotifyDevices: [],
  isShowCritical: false,
  detectionAlerts: [],
  liveCameraSerials: [],
  isFilteringAlerts: false,
  detectionEventCommon: [],
};
const HOSTNAME = window.location.hostname;

const appReducer = (state = initialState, { type, payload }) => {
  const shouldShowAlert = true;
  // const shouldShowAlert = state?.isFilteringAlerts
  //   ? state?.liveCameraSerials?.some((item) => item === payload?.serial)
  //   : true;
  switch (type) {
    case ACTION.UPDATE_SOCKET_STATE:
      return { ...state, socketState: payload };
    case ACTION.UPDATE_LOCALE:
      return { ...state, language: payload };

    case ACTION.UPDATE_NAMESPACE:
      if (!payload?.data) {
        if (state.isAuth === 1) return { ...state };
      }

      const forceChangeNamespace = localStorage.getItem(
        'force_change_namespace',
      );

      const updateNamespace = forceChangeNamespace
        ? forceChangeNamespace
        : payload?.action === 'change'
          ? payload?.data
          : HOSTNAME === 'cloudcam1.hoasengroup.vn'
            ? 'hoasengroup.vn'
            : HOSTNAME === 'cloudcam.hoasenhome.vn'
              ? 'hoasenhome.vn'
              : payload?.data;
      beeXLogger.debug('UPDATE_NAMESPACE - payload: ', payload);
      beeXLogger.debug('UPDATE_NAMESPACE - updateNamespace: ', updateNamespace);
      localStorage.setItem(SYSTEM.NAMESPACE, updateNamespace);
      return { ...state, namespace: updateNamespace };

    case ACTION.AUTH_RETURN_TOKEN:
      // todo(khoidn): handle sip account
      const {
        accessToken,
        id,
        actionLogId,
        lastVisited,
        streamToken,
        namespaceConfiguration,
        autoLogoutSession,
        allowMultiTab,
        namespace,
      } = payload;
      const fingerPrintKey = storageService.getInternalStorageByKey(
        SYSTEM.FINGERPRINT_KEY,
      );
      const encryptedToken = CryptoJS.AES.encrypt(
        accessToken,
        fingerPrintKey,
      ).toString();
      storageService.setInternalStorageByKey(
        SYSTEM.DECODED_ACCESS_TOKEN,
        accessToken,
      );

      localStorage.setItem(SYSTEM.ALLOW_MULTI_TABS, allowMultiTab ? 1 : 0);

      if (autoLogoutSession) {
        localStorage.setItem(SYSTEM.AUTO_LOGOUT_SESSION, autoLogoutSession);
      }

      localStorage.setItem(SYSTEM.TOKEN, encryptedToken);

      if (namespaceConfiguration && JSON.parse(namespaceConfiguration)) {
        const autoLogoutSession =
          JSON.parse(namespaceConfiguration)?.autoLogoutSession || 2;

        const defaultQualityLevel = JSON.parse(
          namespaceConfiguration,
        )?.defaultQualityLevel;

        localStorage.setItem(SYSTEM.AUTH_LOGOUT_SESSION, autoLogoutSession);

        if (defaultQualityLevel) {
          sessionStorage.setItem(
            SYSTEM.DEFAULT_QUALITY_LEVEL,
            defaultQualityLevel,
          );
        }
      }

      const { host } = window.location;
      if (host.split('.').length > 2) {
        const domainParts = host.split('.');
        domainParts.shift();
        const domain = `.${domainParts.join('.')}`;
        Cookies.set(SYSTEM.TOKEN, encryptedToken, { expires: 90, domain });
      } else {
        Cookies.set(SYSTEM.TOKEN, encryptedToken, { expires: 90 });
      }
      return {
        ...state,
        isAuth: 1,
        userId: id,
        authData: null,
        invalidAuthData: null,
        actionLogId,
        lastVisited,
        streamToken,
        // namespace,
      };
    case ACTION.AUTH_INVALID_RETURN:
      return {
        ...state,
        invalidAuthData: payload,
      };

    case ACTION.LIST_NAMESPACE_RETURN: {
      beeXLogger.debug('LIST_NAMESPACE_RETURN - payload: ', payload);
      return {
        ...state,
        namespaces:
          payload && payload.length > 0
            ? payload.map((child) => child.namespace)?.filter((ns) => ns)
            : ['beex.vn'],
      };
    }

    case ACTION.AUTH_LOGIN_RETURN:
      return { ...state, authData: payload };

    case ACTION.GET_PUBLIC_IP:
      return { ...state, public_ip: payload };

    case ACTION.AUTH_LOG_OUT:
      try {
        localStorage.removeItem(SYSTEM.TOKEN);
        localStorage.removeItem(SYSTEM.NAMESPACE);
        // localStorage.removeItem(SYSTEM.GOOGLE_CLIENT_ID);
        // localStorage.removeItem(SYSTEM.GOOGLE_NAMESPACE);
        // localStorage.removeItem(SYSTEM.GOOGLE_USERNAME);
        localStorage.removeItem(SYSTEM.AUTO_LOGOUT_SESSION);
        localStorage.removeItem(SYSTEM.MAX_ENABLE_INACTIVE_LOGOUT);
        localStorage.removeItem(SYSTEM.LAST_ACTIVE_TIME);

        const { host: hostName } = window.location;
        if (hostName.split('.').length > 2) {
          const domainParts = hostName.split('.');
          domainParts.shift();
          const domain = `.${domainParts.join('.')}`;
          Cookies.set(SYSTEM.TOKEN, encryptedToken, { expires: 90, domain });
          Cookies.remove(SYSTEM.TOKEN, { domain });
        } else {
          Cookies.remove(SYSTEM.TOKEN);
        }
      } catch (error) {
        console.log('logout error', error);
      }

      return {
        language: state.language,
        public_ip: state.public_ip,
        socketState: state.socketState,
        isAuth: -1,
      };
    // get user info
    case ACTION.GET_USER_INFO_RETURN: {
      const {
        fullName,
        birthday,
        address,
        avatar,
        phoneNumber,
        balance,
        idSocial,
        configuration,
        createdAt,
        email,
        role,
        apiAccessToken,
        accountConfiguration,
        integrate,
        enableWatermark = 0,
      } = payload;
      let sipAccount = {};
      if (integrate) {
        const integrateData = JSON.parse(integrate);
        sipAccount = {
          username: integrateData?.sipUsername,
          endpoint: integrateData?.sipEndpoint,
          password: integrateData?.sipPassword,
        };
      }

      if (accountConfiguration) {
        const acConfig = JSON.parse(accountConfiguration);
        if (acConfig.autoLogoutSession) {
          localStorage.setItem(
            SYSTEM.AUTO_LOGOUT_SESSION,
            acConfig.autoLogoutSession,
          );
        }

        // config auto logout when timeout interaction
        if (acConfig.interactionTimeout && acConfig.interactionTimeout !== -1) {
          localStorage.setItem(
            SYSTEM.MAX_ENABLE_INACTIVE_LOGOUT,
            acConfig.interactionTimeout,
          );
        }
      }

      return {
        ...state,
        dataUser: { ...(state?.dataUser || {}), ...payload },
        sipAccount,
      };
    }
    case ACTION.SEARCH_CONTACT_RETURN:
      return { ...state, searchContacts: payload };

    case ACTION.LIST_CAMERA_STORAGE_RETURN:
      let cameraStorage = payload.map((record) => ({
        ...record,
        duration: secondsToTime(record.duration),
        hour: Math.trunc(record.minute / 60) % 24,
        from: minutesToTime(record.minute),
        to: minutesToTime(record.minute + Math.floor(record.duration / 60)),
      }));
      return { ...state, cameraStorage };

    case ACTION.RESET_CAMERA_STORAGE_RETURN:
      return { ...state, cameraStorage: null, camerasDate: null };

    case ACTION.GENERATE_LINK_STORAGE_FILE_RETURN:
      return { ...state, decryptData: payload };

    case ACTION.SET_PLAY_VIDEO_AT_PAGE:
      return { ...state, playVideoAtPage: payload };

    case ACTION.UPDATE_DEVICE_RETURN:
      return { ...state, updateDevice: payload };

    case ACTION.DEVICES_MAP_RETURN:
      return { ...state, detailDevicesMap: payload };

    case ACTION.UPDATE_NOTIFICATION_DEVICE_ON_MAPS:
      if (payload.device.state === 0) {
        // device offline --> update last time
        // const isExisted = (state.mapsNotifyDevices || []).find(
        //   (item) => item.serial === payload.device.serial
        // );
        // if (!isExisted) {
        //   return {
        //     ...state,
        //     mapsNotifyDevices: [
        //       ...state.mapsNotifyDevices,
        //       { ...payload.device, lastUpdateTime: new Date().getTime() },
        //     ],
        //   };
        // } else {
        return {
          ...state,
          mapsNotifyDevices: (state.mapsNotifyDevices || []).map((device) => {
            if (device.serial === payload.device.serial) {
              return {
                ...device,
                lastUpdateTime: new Date().getTime(),
              };
            } else {
              return device;
            }
          }),
        };
        // }
      }

      if (payload.device.state === 1) {
        // device online --> remove device
        return {
          ...state,
          mapsNotifyDevices: (state.mapsNotifyDevices || []).filter(
            (device) => device.serial !== payload.device.serial,
          ),
        };
      }

      return {
        ...state,
      };

    case ACTION.AUTO_REMOVE_NOTIFY_DEVICE_ON_MAP:
      return {
        ...state,
        mapsNotifyDevices: (state.mapsNotifyDevices || []).filter((device) => {
          if (
            getDiffTimeFromNow(device.lastUpdateTime) <
            SYSTEM.MAX_DELAY_SHOW_WARNING
          ) {
            return true;
          }
          return false;
        }),
      };
    case ACTION.DEVICE_CHANGE_STATE_RETURN: {
      const cameraStatesUpdate = {
        ...state.cameraStatesUpdate,
        [payload.device.serial]: payload.device.state,
      };

      if (payload.device.deviceType === 'camera') {
        if (!state.cameras) {
          return {
            ...state,
            cameraStatesUpdate,
          };
        }

        if (state.cameras.data && state.cameras.data.length > 0) {
          // const isExisted = state.cameras.data.find(
          //   (item) => item.serial === payload.device.serial
          // );
          // if (!isExisted) {
          //   return {
          //     ...state,
          //     cameras: {
          //       ...state.cameras,
          //       data: [...state.cameras.data, payload.device],
          //     },
          //   };
          // }
          // beeXLogger.debug("DEVICE_CHANGE_STATE_RETURN - payload: ", payload)
          // beeXLogger.debug("DEVICE_CHANGE_STATE_RETURN - cameraStatesUpdate: ", cameraStatesUpdate)
          return {
            ...state,
            cameras: {
              ...state.cameras,
              data: state.cameras.data.map((gate) => {
                if (gate.serial !== payload.device.serial) {
                  return gate;
                }
                return {
                  ...gate,
                  state: payload.device.state,
                };
              }),
            },
            cameraStatesUpdate,
          };
        } else {
          return {
            ...state,
            cameras: {
              ...state.cameras,
              data: [payload.device],
            },
            cameraStatesUpdate,
          };
        }
      }

      if (
        payload.device.deviceType === 'gateway' &&
        state.gateways &&
        state.gateways.data &&
        state.gateways.data.length > 0
      ) {
        if (state.gateways.data && state.gateways.data.length > 0) {
          // const isExisted = state.gateways.data.find(
          //   (item) => item.serial === payload.device.serial
          // );
          // if (!isExisted) {
          //   return {
          //     ...state,
          //     gateways: {
          //       ...state.gateways,
          //       data: [...state.gateways.data, payload.device],
          //     },
          //   };
          // }

          return {
            ...state,
            gateways: {
              ...state.gateways,
              data: state?.gateways?.data?.map((gate) => {
                if (gate.serial !== payload.device.serial) {
                  return gate;
                }
                return {
                  ...gate,
                  state: payload.device.state,
                };
              }),
            },
          };
        } else {
          return {
            ...state,
            gateways: {
              ...state.gateways,
              data: [payload.device],
            },
          };
        }
      }

      if (
        payload.device.deviceType === 'speaker_sip' &&
        state.gateways &&
        state.gateways.data &&
        state.gateways.data.length > 0
      ) {
        const isExisted = state.gateways.data.find(
          (item) => item.serial === payload.device.gatewaySerial,
        );

        if (isExisted) {
          return {
            ...state,
            gateways: {
              ...state.gateways,
              data: (state.gateways.data || []).map((item) => {
                return {
                  ...item,
                  expands: {
                    ...item.expands,
                    speakerSips: (item.expands?.speakerSips || []).map(
                      (sip) => {
                        if (sip.serial !== payload.device.serial) {
                          return sip;
                        }
                        return {
                          ...sip,
                          state: payload.device.state,
                        };
                      },
                    ),
                  },
                };
              }),
            },
          };
        }
      }

      return { ...state };
    }

    case ACTION.STATISTIC_DEVICE_STATUS_RETURN:
      if (payload?.deviceType === 'camera') {
        return {
          ...state,
          cameras: {
            ...state.cameras,
            numberMaintain: payload?.numberMaintain,
            numberOffline: payload?.numberOffline,
            numberOnline: payload?.numberOnline,
          },
        };
      }
      if (payload.deviceType === 'gateway') {
        return {
          ...state,
          gateways: {
            ...state.gateways,
            numberMaintain: payload?.numberMaintain,
            numberOffline: payload?.numberOffline,
            numberOnline: payload?.numberOnline,
          },
        };
      }
      return { ...state };

    case ACTION.REMOVE_DEVICE_RETURN:
      return {
        ...state,
        cameras: {
          ...state.cameras,
          data: (state.cameras.data || []).filter(
            (camera) => camera.serial !== payload,
          ),
        },
      };

    case ACTION.LIST_STATE_CAMERA_RETURN:
      return { ...state, cameraStates: payload };

    case ACTION.LIST_STATE_GATEWAY_RETURN:
      return { ...state, gatewayStates: payload };

    case ACTION.LIST_CAMERA_BY_PAGE_RETURN:
      return {
        ...state,
        cameras: {
          data: payload.devices,
          totalSize: payload.total,
          isLastPage: payload.isLastPage,
          page: payload.page,
          timeRequest: payload.timeRequest,
          requestId: payload.requestId,
        },
      };
    case ACTION.RESET_CAMERA_BY_PAGE_RETURN:
      return {
        ...state,
        cameras: null,
      };

    case ACTION.LIST_GATEWAY_BY_PAGE_RETURN:
      let data = payload.devices.map((gate) => ({
        name: gate.name,
        ownerId: gate.ownerId,
        maxAvailable: gate.maxAvailable,
        note: gate.note,
        lat: gate.lat,
        lng: gate.lng,
        state: gate.state,
        ipAddress: gate.ipAddress,
        localAddress: gate.localAddress,
        portScan: gate.portScan,
        serial: gate.serial,
        targetId: gate.targetId,
        deviceType: gate.deviceType,
        tags: gate.tags,
        performance: {
          cpu: gate.cpu,
          temperature: gate.temperature,
          ram: gate.ram,
          disk: gate.disk,
          totalDisk: gate.totalDisk,
          networkIn: gate.networkIn,
          networkOut: gate.networkOut,
        },
        contact: gate.contact,
      }));
      return {
        ...state,
        gateways: {
          data,
          totalSize: payload.total,
          isLastPage: payload.isLastPage,
          page: payload.page,
          timeRequest: payload.timeRequest,
        },
      };

    case ACTION.SEARCH_DEVICE_BY_NAME_RETURN:
      return { ...state, searchDevices: payload };

    case ACTION.LIST_DEVICE_AND_SHARE_EXTEND_RETURN:
      let extendTree_ = [
        ...payload.devices.map((child) => ({
          title: child.name,
          key: child.serial,
          serial: child.serial,
          thumbnail: child.thumbnail,
          icon:
            child.state === 1 ? (
              <img
                width={22}
                height={22}
                alt="streaming on"
                src={StreamingOn}
              />
            ) : (
              <img
                width={16}
                height={16}
                alt="streaming off"
                src={StreamingOff}
              />
            ),
          isLeaf: true,
        })),
        ...payload.users
          .map((child, index) => ({
            title: child.alias,
            shareUserId: child.shareUserId,
            key: new Date().getTime() + index,
            icon: <ApartmentOutlined />,
            disableCheckbox: true,
            isTravel: false,
            isLeaf: false,
          }))
          .sort((a, b) => a.key - b.key),
      ];

      return {
        ...state,
        cameraTree: {
          owned:
            state.cameraTree && state.cameraTree.owned
              ? state.cameraTree.owned
              : [],
          shared: [
            ...(state.cameraTree && state.cameraTree.shared
              ? state.cameraTree.shared
              : []),
            ...payload.devices,
          ],
          tree: state.cameraTree.tree,
        },

        extendTree: {
          data: extendTree_,
          shareUserId: payload.shareUserId,
        },
      };

    case ACTION.GATEWAY_UPDATE_INFO_RETURN:
      const state_status = payload.state;
      const {
        totalDisk,
        deviceSerial,
        disk,
        cpu,
        ram,
        networkIn,
        temperature,
        networkOut,
      } = payload;
      if (!state.gateways) {
        return { ...state };
      }

      return {
        ...state,
        gateways: {
          ...state.gateways,
          data: state?.gateways?.data?.map((gate) => {
            if (gate.serial !== deviceSerial) {
              return gate;
            }
            return {
              ...gate,
              performance: {
                ...gate.performance,
                temperature,
                networkIn,
                networkOut,
                cpu,
                state: state_status,
                ram,
                disk: disk,
                totalDisk: totalDisk,
              },
            };
          }),
        },
      };

    case ACTION.CAMERA_UPDATE_INFO_RETURN:
      const camera_status = payload.dataUpdateCamera?.state;
      const { name, thumbnail, serial } = payload.dataUpdateCamera;
      return {
        ...state,
        cameraStates: {
          ...state.cameraStates,
          data:
            state.cameraStates &&
            state.cameraStates.data?.map((camera) => {
              if (camera.serial !== serial) {
                return camera;
              }
              return {
                ...camera,
                name,
                thumbnail,
                state: camera_status,
              };
            }),
          requestId: payload.requestId,
        },
      };
    case ACTION.GET_DEVICE_INFO_EXTRA_RETURN:
      console.log('Data: ', payload);
      return {
        ...state,
        gateways: {
          ...state.gateways,
          data: state?.gateways?.data?.map((data) => {
            if (data.serial !== payload.serial) {
              return data;
            }
            return {
              ...data,
              expands: { ...payload },
            };
          }),
        },
      };
    // Add gateway
    case ACTION.REQUIRE_ACTIVE_DEVICE_RETURN:
      return {
        ...state,
        addDeviceData: payload,
      };
    case ACTION.CHECK_EXTERNAL_DEVICE_RETURN:
      console.log('external', payload);
      return {
        ...state,
        checkExternalDevice: payload,
      };
    case ACTION.REQUIRE_ADD_DEVICE_RETURN:
      return {
        ...state,
        activeDeviceData: payload,
      };
    case ACTION.LIST_USER_SHARE_DEVICE_RETURN: {
      let result =
        payload &&
        payload.users &&
        payload.users.length > 0 &&
        payload.users.reduce((r, { groupId, serial, ...object }) => {
          let temp = r.find(
            (o) =>
              o.groupId === groupId && o.serial === serial && groupId !== -1,
          );
          if (!temp) r.push((temp = { ...object, groupId, serial, child: [] }));
          temp.child.push({ ...object, groupId, serial });
          return r;
        }, []);

      result =
        (result &&
          result.length > 0 &&
          result.map((item, index) => ({
            ...item,
            id: index,
            child:
              item.groupId !== -1
                ? item.child.map((chil, number) => ({
                  ...chil,
                  key: `${index}_${number}`,
                }))
                : undefined,
          }))) ||
        [];
      // setUserShares({ users: [...result], serials: payload.serials });
      const data = result.sort((a, b) => b.groupId - a.groupId);
      return {
        ...state,
        userShareDevice: { users: [...data], serials: payload.serials },
      };
    }

    case ACTION.LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE_RETURN: {
      return {
        ...state,
        userGroupsByDeviceGroups: payload,
      };
    }

    case ACTION.SHARE_PERMISSION_USER:
      return {
        ...state,
        sharePermissionUsers: payload,
      };

    case ACTION.UN_SHARE_PERMISSION_USER_RETURN:
      return {
        ...state,
        unShareUser: payload,
      };

    // Add camera
    case ACTION.CHECK_STREAM_RETURN:
      console.log('CHECK_STREAM_RETURN', payload);
      // console.log('CHECK_STREAM_RETURN', payload);
      return {
        ...state,
        checkStreamSource: payload,
        checkStreamSources: [...(state.checkStreamSources || []), payload],
      };

    // Clear streams
    case ACTION.CLEAR_STREAM_RETURN:
      return {
        ...state,
        checkStreamSources: payload,
      };

    // Check rtsp stream
    case ACTION.CHECK_RTSP_STREAM_RETURN:
      console.log('payload', payload);
      // console.log('CHECK_RTSP_STREAM_RETURN', payload);
      return { ...state, checkRtspStreamReturn: payload };

    case ACTION.SCAN_STREAM_RETURN:
      console.log('SCAN_STREAM_RETURN', payload);
      return { ...state, scanStreamSource: payload };

    case ACTION.ADD_EXTERNAL_DEVICE_RETURN:
      console.log('ADD_EXTERNAL_DEVICE_RETURN', payload);
      // console.log('ADD_EXTERNAL_DEVICE_RETURN', payload);
      return { ...state, addExternalDevice: payload };

    // Add camera

    // Notification
    case ACTION.LIST_NOTIFICATION_RETURN:
      return {
        ...state,
        notifications: payload.notifications,
        totalNotifications: payload.unreads,
      };

    // Update status notification
    case ACTION.UPDATE_NOTIFICATION_RETURN:
      return { ...state, updateNotifications: payload };

    // New notification
    case ACTION.NEW_NOTIFICATION_RETURN:
      return {
        ...state,
        notifications:
          state.notifications?.length >= 0
            ? state.notifications.concat(payload)
            : [payload],
        totalNotifications: state.totalNotifications
          ? state.totalNotifications + 1
          : 1,
        markUnreadNotifications: undefined,
        totalUnreadNotifications: state.totalUnreadNotifications
          ? state.totalUnreadNotifications + 1
          : 1,
      };
    // New notification detail
    case ACTION.NEW_NOTIFICATION_DETAIL_RETURN:
      return {
        ...state,
        notificationDetail: payload,
      };
    // mark unread notification
    case ACTION.MARK_READ_NOTIFICATION_RETURN:
      return { ...state, markUnreadNotifications: payload };
    case ACTION.RESET_TOTAL_UNREAD_NOTIFICATION_RETURN:
      return { ...state, totalUnreadNotifications: 0 };
    // filter notification
    case ACTION.FILTER_NOTIFICATION_RETURN:
      return { ...state, filterNotifications: payload };

    // Service
    case ACTION.LIST_SERVICE_RETURN:
      // console.log("payload: ", payload);
      return {
        ...state,
        services: payload.services,
        // services: payload.services.filter((service) =>
        //   service.resources.includes('camera')
        // ),
      };

    case ACTION.LIST_SERVICE_BY_DEVICE_SERIAL_RETURN:
      return {
        ...state,
        servicesCamera: payload.services,
      };

    case ACTION.LIST_DEVICE_BY_SERVICE_ID_RETURN:
      return {
        ...state,
        devicesOfServices: payload,
      };
    case ACTION.LIST_TARGET_BY_SERVICE_ID_RETURN:
      return {
        ...state,
        targetsOfServices: payload,
      };
    case ACTION.LIST_DEVICE_ACTIVE_SERVICE_ID_RETURN:
      return {
        ...state,
        devicesActiveOfServices: payload,
      };
    case ACTION.LIST_TARGET_ACTIVE_SERVICE_ID_RETURN:
      return {
        ...state,
        targetActiveOfServices: payload,
      };
    case ACTION.CONFIGURATION_SERVICE_RETURN:
      return {
        ...state,
        configurationService: payload,
      };
    case ACTION.GET_LICENSE_INFO_SERVICE_RETURN:
      return { ...state, checkLicense: payload };

    case ACTION.ACTIVE_LICENSE_SERVICE_RETURN:
      // console.log(payload);
      return { ...state, activeLicense: payload };
    // Service
    case ACTION.CANCEL_LICENSE_SERVICE_RETURN:
      // console.log('CANCEL_LICENSE_SERVICE_RETURN', payload);
      return {
        ...state,
        targetsOfServices: {
          ...state.targetsOfServices,
          perDevice: state.targetsOfServices.perDevice?.map((device) =>
            !device.service ||
              device.serial !== payload.deviceSerial ||
              device.service.serviceId !== payload.serviceId
              ? device
              : { ...device, service: undefined },
          ),
          perAccount: state.targetsOfServices.perAccount?.map((device) =>
            !device.service ||
              device.accountId !== payload.accountId ||
              device.service.serviceId !== payload.serviceId
              ? device
              : { ...device, service: undefined },
          ),
          perNamespace: payload.serviceId ? undefined : {},
        },
      };
    // Service

    // Stream camera
    case ACTION.CREATE_STREAM:
      if (!state.streams || state.streams.length === 0) {
        return {
          ...state,
          streams: [
            {
              serial: payload.serial,
              streamId: payload.streamId,
              sdpOffer: null,
              started: false,
              status: null,
            },
          ],
        };
      }
      if (
        state.streams &&
        state.streams.some((stream) => stream.serial === payload.serial)
      ) {
        return {
          ...state,
          streams: state.streams.map((stream) =>
            stream.serial === payload.serial
              ? {
                serial: payload.serial,
                streamId: payload.streamId,
                sdpOffer: null,
                started: false,
                status: null,
              }
              : stream,
          ),
        };
      }

      return {
        ...state,
        streams: state.streams.concat({
          serial: payload.serial,
          streamId: payload.streamId,
          sdpOffer: null,
          started: false,
          status: null,
        }),
      };

    case ACTION.START_STREAM_MONITOR: {
      // const camerasMode = localStorage.getItem('pinned_cameras_mode')
      const camerasMode = state.pinnedCamerasMode;
      const modeCameraStorage = localStorage.getItem('mode_camera');
      const camerasModeTemp =
        camerasMode && JSON.parse(camerasMode)
          ? JSON.parse(camerasMode)?.find(
            (item) => item?.serial === payload.serial,
          )
          : null;
      if (!state.streams || state.streams.length === 0) {
        return {
          ...state,
          streams: [
            {
              serial: payload.serial,
              streamMonitorId: payload.streamMonitorId,
              streamId: null,
              sdpOffer: null,
              started: false,
              status: null,
              path: payload.path,
              wsHost: payload.wsHost,
              wssPort: payload.wssPort,
              subSources: payload.subSources,
              mainSource: payload.mainSource,
              protocol: payload.protocol,
              ...payload,
              // hlsPort: camerasModeTemp ? (camerasModeTemp?.mode === 'Fast' ? payload.hlsPort : null) : (payload?.protocol === 'hls' ? payload.hlsPort : null),
              // hlsPort: camerasModeTemp
              //   ? camerasModeTemp?.mode === 'Fast'
              //     ? payload.hlsPort
              //     : null
              //   : modeCameraStorage && modeCameraStorage !== 'auto'
              //   ? modeCameraStorage === 'fast'
              //     ? payload.hlsPort
              //     : null
              //   : payload?.protocol === 'hls'
              //   ? payload.hlsPort
              //   : null,
              version: payload.version,
              preferedProtocol: camerasModeTemp?.mode,
            },
          ],
        };
      }

      if (
        state.streams &&
        state.streams.some((stream) => stream.serial === payload.serial)
      ) {
        return {
          ...state,
          streams: state.streams.map((stream) =>
            stream.serial === payload.serial
              ? {
                serial: payload.serial,
                streamMonitorId: payload.streamMonitorId,
                streamId: null,
                sdpOffer: null,
                started: false,
                status: null,
                path: payload.path,
                wsHost: payload.wsHost,
                wssPort: payload.wssPort,
                subSources: payload.subSources,
                mainSource: payload.mainSource,
                protocol: payload.protocol,
                // hlsPort: camerasModeTemp ? (camerasModeTemp?.mode === 'Fast' ? payload.hlsPort : null) : (payload?.protocol === 'hls' ? payload.hlsPort : null),
                // hlsPort: camerasModeTemp
                //   ? camerasModeTemp?.mode === 'Fast'
                //     ? payload.hlsPort
                //     : null
                //   : modeCameraStorage && modeCameraStorage !== 'auto'
                //   ? modeCameraStorage === 'fast'
                //     ? payload.hlsPort
                //     : null
                //   : payload?.protocol === 'hls'
                //   ? payload.hlsPort
                //   : null,
                ...payload,
                version: payload.version,
                preferedProtocol: camerasModeTemp?.mode,
              }
              : stream,
          ),
        };
      }

      return {
        ...state,
        streams: state.streams.concat({
          serial: payload.serial,
          streamMonitorId: payload.streamMonitorId,
          streamId: null,
          sdpOffer: null,
          started: false,
          status: null,
          path: payload.path,
          wsHost: payload.wsHost,
          wssPort: payload.wssPort,
          subSources: payload.subSources,
          mainSource: payload.mainSource,
          protocol: payload.protocol,
          // hlsPort: camerasModeTemp ? (camerasModeTemp?.mode === 'Fast' ? payload.hlsPort : null) : (payload?.protocol === 'hls' ? payload.hlsPort : null),
          // hlsPort: camerasModeTemp
          //   ? camerasModeTemp?.mode === 'Fast'
          //     ? payload.hlsPort
          //     : null
          //   : modeCameraStorage && modeCameraStorage !== 'auto'
          //   ? modeCameraStorage === 'fast'
          //     ? payload.hlsPort
          //     : null
          //   : payload?.protocol === 'hls'
          //   ? payload.hlsPort
          //   : null,
          ...payload,
          version: payload.version,
          preferedProtocol: camerasModeTemp?.mode,
        }),
      };
    }

    case ACTION.START_STREAM_MONITOR_FAILURE: {
      return {
        ...state,
        streamsFailure: [...(state?.streamsFailure || []), payload],
      };
    }
    case ACTION.REMOVE_START_STREAM_MONITOR_FAILURE: {
      return {
        ...state,
        streamsFailure: [...(state?.streamsFailure || [])]?.filter(
          (item) => item?.requestId !== payload,
        ),
      };
    }

    case ACTION.REMOVE_STREAM: {
      beeXLogger.debug('REMOVE_STREAM: ', payload);
      return {
        ...state,
        streams: (state.streams
          ? Array.isArray(state?.streams)
            ? state?.streams
            : []
          : []
        ).filter((stream) => stream.serial !== payload),
      };
    }

    case ACTION.RECONNECT_STREAM: {
      return {
        ...state,
        reconnectStream: payload,
      };
    }

    case ACTION.WATCH_STREAM:
      return {
        ...state,
        streams: state.streams.map((stream) =>
          stream.streamId === payload.streamId
            ? {
              ...stream,
              sdpOffer: payload.sdpOffer,
            }
            : stream,
        ),
      };
    case ACTION.START_STREAM:
      return {
        ...state,
        streams: state.streams.map((stream) =>
          stream.streamId === payload.streamId &&
            stream.started !== payload.started
            ? {
              ...stream,
              started: payload.started,
              status: 'live',
            }
            : stream,
        ),
      };

    case ACTION.END_STREAM:
      if (state.streams) {
        return {
          ...state,
          streams:
            state.streams &&
            state.streams.filter((stream) => stream.streamId !== payload),
        };
      }
      return { ...state };
    case ACTION.END_STREAM_ULTRA_FAST:
      if (state.streams) {
        return {
          ...state,
          streams:
            state.streams &&
            state.streams.filter((stream) => stream.serial !== payload),
        };
      }
      return { ...state };
    case ACTION.CLEAR_STREAM:
      return {
        ...state,
        streams: [],
      };
    case ACTION.UPDATE_STREAM_INFO:
      return {
        ...state,
        streams: state.streams
          ? state.streams.map((stream) =>
            payload.status &&
              payload.status !== '' &&
              stream.serial === payload.serial &&
              stream.started === true &&
              stream.status !== 'live'
              ? {
                ...stream,
                status: payload.status,
              }
              : stream,
          )
          : null,
      };

    // System
    case ACTION.LIST_ACCOUNT_BY_NAMESPACE_RETURN:
      return {
        ...state,
        accountByNamespace: payload,
      };

    case ACTION.LIST_ACCOUNT_BY_NAMESPACE_BY_PAGE_RETURN:
      return {
        ...state,
        accountByNamespaceByPage: payload,
      };

    case ACTION.LIST_DETAIL_ROLE_OF_CUSTOMER_RETURN:
      return {
        ...state,
        detailRoleOfCustomer: payload,
      };

    case ACTION.LIST_ACTION_LOG_BY_NAMESPACE_RETURN:
      return {
        ...state,
        logsByNamespace: payload,
      };

    case ACTION.LIST_WHITE_LIST_IP_BY_NAMESPACE_RETURN:
      return {
        ...state,
        whiteListIPs: payload,
      };
    case ACTION.ADD_WHITE_LIST_IP_RETURN:
      return {
        ...state,
        addWhiteListIPs: payload,
      };
    case ACTION.DELETE_WHITE_LIST_IP_RETURN:
      return {
        ...state,
        deleteWhiteListIP: payload,
      };
    case ACTION.ADD_MEMBER_TO_NAMESPACE_RETURN:
      return {
        ...state,
        accountByNamespace: [...state.accountByNamespace, payload.data],
        addMemberToNamespace: payload,
      };
    case ACTION.UPDATE_MEMBER_TO_NAMESPACE_RETURN:
      return {
        ...state,
        updateMemberToNamespace: payload,
      };

    case ACTION.UPDATE_PASSWORD_MEMBER_TO_NAMESPACE_RETURN:
      return {
        ...state,
        updatePasswordMemberToNamespace: payload,
      };
    case ACTION.REMOVE_MEMBER_TO_NAMESPACE_RETURN: {
      if (!payload) {
        return {
          ...state,
          removeMemberToNamespace: payload,
        };
      }

      const { namespace, phonenumber } = payload;

      return {
        ...state,
        accountByNamespace: state.accountByNamespace.filter(
          (account) =>
            !(
              account.phonenumber === phonenumber &&
              account.namespace === namespace
            ),
        ),
        removeMemberToNamespace: payload,
      };
    }
    case ACTION.RESET_TOKEN_RETURN: {
      const encryptedToken = CryptoJS.AES.encrypt(
        payload.token,
        fingerPrintKey,
      ).toString();
      localStorage.setItem(SYSTEM.TOKEN, encryptedToken);
      const { host } = window.location;
      if (host.split('.').length > 2) {
        const domainParts = host.split('.');
        domainParts.shift();
        const domain = `.${domainParts.join('.')}`;
        Cookies.set(SYSTEM.TOKEN, encryptedToken, { expires: 90, domain });
      } else {
        Cookies.set(SYSTEM.TOKEN, encryptedToken, { expires: 90 });
      }
      return { ...state, resetToken: payload };
    }
    case ACTION.RENEW_API_TOKEN_RETURN: {
      return { ...state, reNewApiToken: payload };
    }
    // System

    // sumary camera
    case ACTION.GET_SUMARY_CAMERA_RETURN:
      return {
        ...state,
        sumaryCamera: payload,
      };

    case ACTION.GET_LIST_LICENSE_BY_NAMESPACE:
      return {
        ...state,
        listLicense: payload,
      };

    case ACTION.GET_LIST_DEVICE_GROUP:
      return {
        ...state,
        listDeviceGroup: payload,
      };

    case ACTION.GET_DEVICE_GROUP_BY_ID:
      return {
        ...state,
        deviceGroup: payload,
        totalDevicesGroup: payload.totalDevicesGroup,
      };

    case ACTION.GET_LIST_DEVICE_GROUP_BY_PAGE:
      return {
        ...state,
        listDeviceGroupByPage: payload,
      };

    case ACTION.LIST_DEVICE_BY_DEVICE_GROUP_ID_RETURN:
      return {
        ...state,
        listDeviceByGroupId: payload,
      };

    case ACTION.ADD_DEVICE_TO_GROUP:
      return {
        ...state,
        addDeviceGroup: payload,
      };

    case ACTION.UPDATE_DEVICE_TO_GROUP:
      console.log('payload', payload);
      return {
        ...state,
        updateDeviceGroup: payload,
      };

    case ACTION.DELETE_DEVICE_TO_GROUP:
      return {
        ...state,
        deleteDeviceGroup: payload,
      };

    case ACTION.LIST_DEVICE_SELECT:
      return {
        ...state,
        camerasSelect: {
          data: payload.devices,
          totalSize: payload.total,
          isLastPage: payload.isLastPage,
          page: payload.page,
          timeRequest: payload.timeRequest,
        },
      };

    case ACTION.CLEAR_LIST_DEVICE_SELECT:
      return {
        ...state,
        camerasSelect: {
          data: payload,
          totalSize: null,
          isLastPage: null,
          page: null,
          timeRequest: null,
        },
      };

    case ACTION.LIST_CAMERA_DATE:
      return {
        ...state,
        camerasDate: payload,
      };

    case ACTION.LIST_WHITE_LIST_DEVICE_BY_NAMESPACE_RETURN:
      return {
        ...state,
        whiteListDevices: payload,
      };
    case ACTION.ADD_WHITE_LIST_DEVICE_RETURN:
      return {
        ...state,
        addWhiteListDevice: payload,
      };
    case ACTION.DELETE_WHITE_LIST_DEVICE_RETURN:
      return {
        ...state,
        deleteWhiteListDevice: payload,
      };
    case ACTION.LIST_GROUP_MEMBER_RETURN:
      return {
        ...state,
        groupMembers: payload,
      };
    case ACTION.LIST_DATA_SEARCH_RETURN:
      return {
        ...state,
        listDataSearch: {
          data: payload.records,
          totalSize: payload.totalSize,
        },
      };
    case ACTION.ADD_GROUP_MEMBER_RETURN:
      return {
        ...state,
        addGroupMembers: payload,
      };
    case ACTION.UPDATE_GROUP_MEMBER_RETURN:
      return {
        ...state,
        updateGroupMembers: payload,
      };
    case ACTION.DELETE_GROUP_MEMBER_RETURN:
      return {
        ...state,
        deleteGroupMembers: payload,
      };
    case ACTION.LIST_GROUP_BY_ACCOUNT_RETURN:
      return {
        ...state,
        listGroupByAccount: payload,
      };
    case ACTION.LIST_ACCOUNT_GROUP_MEMBER_RETURN:
      return {
        ...state,
        accountGroupMembers: payload,
      };
    case ACTION.CLEAR_LIST_ACCOUNT_GROUP_MEMBER:
      return {
        ...state,
        accountGroupMembers: [],
      };
    case ACTION.LIST_GROUP_BY_PARENT_GROUP_RETURN:
      return {
        ...state,
        listGroupByParentGroup: payload,
      };
    case ACTION.CHECK_REMOVE_GROUP_RETURN:
      return {
        ...state,
        checkRemoveGroup: payload,
      };
    case ACTION.CLEAR_LIST_GROUP_BY_PARENT_GROUP:
      return {
        ...state,
        listGroupByParentGroup: null,
      };
    case ACTION.ADD_ACCOUNT_GROUP_MEMBER_RETURN:
      return {
        ...state,
        addAccountGroupMembers: payload,
      };
    case ACTION.DELETE_ACCOUNT_GROUP_MEMBER_RETURN:
      return {
        ...state,
        deleteAccountGroupMembers: payload,
      };
    case ACTION.SHARE_PERMISSION_GROUP_RETURN:
      return {
        ...state,
        sharePermissionGroup: payload,
      };
    case ACTION.DELETE_SHARE_PERMISSION_GROUP_RETURN:
      return {
        ...state,
        deleteSharePermissionGroup: payload,
      };
    case ACTION.UPDATE_SHARE_PERMISSION_USER_RETURN:
      return {
        ...state,
        updateSharePermissionGroup: payload,
      };
    case ACTION.GET_DEVICE_CONTACT_INFO_RETURN:
      return {
        ...state,
        listDeviceContact: payload,
        deviceContactInfo: payload,
      };
    case ACTION.LIST_ALERT_RETURN:
      return {
        ...state,
        listAlert: payload,
      };
    case ACTION.STATISTIC_ACTION_LOG_BY_NAMESPACE_RETURN:
      return {
        ...state,
        listStatistic: payload,
      };
    case ACTION.CHECK_AUTHENTICATION_TYPE:
      return {
        ...state,
        listAuthenticationTypeAccount: payload,
      };
    case ACTION.CHECK_LDAP_ACCOUNT_RETURN:
      console.log('LDAP ACCOUNT RETURN', payload);
      return {
        ...state,
        listNamespaceAccount: payload,
      };
    case ACTION.AUTHENTICATION_LDAP_RETURN:
      return {
        ...state,
        authenticationAccount: payload,
      };
    case ACTION.REQUEST_UPLOAD_FILE:
      return {
        ...state,
        requestUploadFile: payload,
      };
    case ACTION.UPLOAD_STORAGE_FILE:
      return {
        ...state,
        uploadStorageFile: payload,
      };
    case ACTION.RESET_UPLOAD_FILE:
      return {
        ...state,
        requestUploadFile: null,
        uploadStorageFile: null,
      };
    case ACTION.REMOVE_STORAGE_FILE_RETURN:
      return {
        ...state,
        removeStorageFile: payload,
      };
    case ACTION.LIST_STORAGE_FILE_BY_TAG:
      return {
        ...state,
        listStorageFileByTag: payload.records,
      };
    case ACTION.SET_LIST_STORAGE_FILE_BY_TAG:
      return {
        ...state,
        listStorageFileByTag: payload,
      };
    case ACTION.UPDATE_TAGS_STORAGE_FILE:
      return {
        ...state,
        updateTagsStorageFile: payload,
      };
    case ACTION.LIST_CAMERA_BY_STATE:
      return {
        ...state,
        listCameraByState: payload,
      };
    case ACTION.LIST_GATEWAY_BY_STATE:
      return {
        ...state,
        listGatewayByState: payload,
      };

    case ACTION.LIST_DEVICE_BY_STATE_FAILURE:
      return {
        ...state,
        listGatewayByState: [],
        listCameraByState: [],
      };
    case ACTION.SET_OPEN_UPLOAD_FILES_DIALOG:
      return {
        ...state,
        openUploadFilesDialog: payload,
      };
    case ACTION.SET_UPLOAD_FILES_CAMERA:
      return {
        ...state,
        uploadFilesCamera: payload,
      };
    case ACTION.SET_UPLOAD_FILES_DATE:
      return {
        ...state,
        uploadFilesDate: payload,
      };
    case ACTION.SET_UPLOAD_FILES_OLD_VIDEOS:
      return {
        ...state,
        uploadFilesOldVideos: payload,
      };
    case ACTION.SET_LIST_NOTIFICATION:
      return {
        ...state,
        listNotificationService: payload,
      };
    case ACTION.DELETE_LIST_NOTIFICATION:
      return {
        ...state,
        listNotificationService: null,
      };
    case ACTION.LIST_DEVICE_BY_USER_RETURN:
      return {
        ...state,
        listDeviceByUser: payload,
      };

    case ACTION.LIST_DEVICE_GROUP_BY_USER_RETURN:
      return {
        ...state,
        listDeviceGroupByUser: payload,
      };
    case ACTION.UPDATE_STATE_DEVICES_RETURN:
      return {
        ...state,
        updateStateDevices: payload,
      };
    case ACTION.SET_PINNED_CAMERAS_MODE_RETURN:
      return {
        ...state,
        pinnedCamerasMode: payload,
      };
    case ACTION.LIST_PLACE_BY_PAGE:
      return {
        ...state,
        listPlaceByPage: payload,
      };
    case ACTION.ADD_PLACE_RETURN:
      return {
        ...state,
        listPlaceByPage: {
          ...state.listPlaceByPage,
          places: [
            {
              placeId: payload?.place?.id,
              name: payload?.place?.name,
              namespace: payload?.place?.namespace,
              lat: payload?.place?.lat,
              lng: payload?.place?.lng,
              deviceGroupId: -1,
            },
            ...(state.listPlaceByPage?.places ?? []),
          ],
        },
      };
    case ACTION.REMOVE_PLACE_RETURN:
      return {
        ...state,
        listPlaceByPage: {
          ...state.listPlaceByPage,
          places:
            state.listPlaceByPage?.places?.filter(
              (atm) => atm.placeId !== payload,
            ) ?? [],
        },
      };
    case ACTION.REQUEST_MAKE_CALL_RETURN:
      return {
        ...state,
        sipAccount: payload?.configuration
          ? JSON.parse(payload.configuration)
          : {},
      };

    case ACTION.CHANGE_DIAL_PAD_DATA:
      return {
        ...state,
        dialPad: payload,
      };

    case ACTION.GENERATE_LINK_STORAGE_FILE_BY_TIME_RETURN:
      return {
        ...state,
        generateLinkStorageFileByTime: payload,
      };
    case ACTION.POPUP_VIDEO_STORAGE_FILE_BY_TIME_RETURN:
      return {
        ...state,
        popupVideoStorageFileByTime: payload,
      };
    case ACTION.GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_SUCCESS:
      return {
        ...state,
        listDeviceGroups: payload.data,
        loadingGetListDevice: false,
      };

    case ACTION.GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_RETURN:
      return {
        ...state,
        loadingGetListDevice: true,
      };
    case ACTION.GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_FAIL:
      return {
        ...state,
        loadingGetListDevice: false,
      };

    case ACTION.GENERATE_SHORT_TOKEN_RETURN:
      return {
        ...state,
        shortTokenData: payload,
      };
    case ACTION.SET_SHOW_CRITICAL:
      return {
        ...state,
        isShowCritical: payload,
      };
    case ACTION.GET_LIST_GPS_LOCATION:
      return {
        ...state,
        listGpsLocation: payload,
      };
    case ACTION.GET_LIST_SPEAKER_SIP:
      return {
        ...state,
        listSpeakerSip: payload,
      };
    case ACTION.GET_REPORT_BY_NAMESPACE_SUCCESS:
      return {
        ...state,
        reportByNamespace: payload,
      };

    case ACTION.UPDATE_DEVICE_REPORTS_CAUSE_SUCCESS:
      return {
        ...state,
        updateDeviceReportsCause: payload,
      };
    case ACTION.CLEAR_LIST_ALL_DEVICE_BY_GROUP:
      return {
        ...state,
        listDeviceByGroupId: payload,
      };
    case ACTION.TOGGLE_SMART_MODE:
      return {
        ...state,
        enabledSmartMode: payload,
      };
    case ACTION.DETECT_OBJECT:
      if (!!state.enabledSmartMode && shouldShowAlert) {
        return {
          ...state,
          detectionAlerts: [
            { ...payload, serviceId: SERVICE.DETECT_OBJECT },
            ...(state.detectionAlerts || []),
          ],
        };
      }
      return state;
    case ACTION.DETECT_FACE:
    case ACTION.DETECT_PERSON:
      if (payload.namespace !== state.namespace) {
        return state;
      }

      // console.log(
      //   'PERSON OR FACE',
      //   payload,
      //   shouldShowAlert,
      //   !!state.enabledSmartMode
      // );

      if (!!state.enabledSmartMode && shouldShowAlert) {
        const identifier =
          payload.recordId +
          payload.objects +
          payload.actionTime +
          payload.imageUrl;

        const isExist = (state.detectionAlerts || []).some(
          (alert) => alert.clientId === identifier,
        );

        if (isExist) {
          return state;
        }

        return {
          ...state,
          detectionAlerts: [
            {
              ...payload,
              serviceId: SERVICE.DETECT_PERSON,
              clientId: identifier,
            },
            ...(state.detectionAlerts || []),
          ],
        };
      }
      return state;
    case ACTION.DETECT_WEAPON:
      if (!!state.enabledSmartMode && shouldShowAlert) {
        return {
          ...state,
          detectionAlerts: [
            { ...payload, serviceId: SERVICE.DETECT_WEAPON },
            ...(state.detectionAlerts || []),
          ],
        };
      }
      return state;
    case ACTION.DETECT_FIRE:
      if (!!state.enabledSmartMode && shouldShowAlert) {
        return {
          ...state,
          detectionAlerts: [
            { ...payload, serviceId: SERVICE.DETECT_FIRE },
            ...(state.detectionAlerts || []),
          ],
        };
      }
      return state;
    case ACTION.DETECT_VIRTUAL_WALL:
      if (!!state.enabledSmartMode && shouldShowAlert) {
        return {
          ...state,
          detectionAlerts: [
            { ...payload, serviceId: SERVICE.DETECT_VIRTUAL_WALL },
            ...(state.detectionAlerts || []),
          ],
        };
      }
      return state;
    case ACTION.RECOGNITION_FACE:
      if (!!state.enabledSmartMode && shouldShowAlert) {
        return {
          ...state,
          detectionAlerts: [
            { ...payload, serviceId: SERVICE.RECOGNITION_FACE },
            ...(state.detectionAlerts || []),
          ],
        };
      }
      return state;
    case ACTION.DETECT_EVENT_COMMON:
      return {
        ...state,
        detectionEventCommon: [
          { ...payload },
          ...(state.detectionEventCommon || []),
        ],
      };
    case ACTION.CLEAR_ALERT:
      return {
        ...state,
        detectionAlerts: [],
      };

    case ACTION.SET_CAMERA_SERIALS:
      return {
        ...state,
        liveCameraSerials: [
          ...(state?.liveCameraSerials || []),
          ...(payload || []),
        ],
      };

    case ACTION.CLEAR_CAMERA_SERIALS:
      return {
        ...state,
        liveCameraSerials: [],
      };

    case ACTION.SET_FILTERING_ALERTS:
      return {
        ...state,
        isFilteringAlerts: payload,
      };

    // Face terminal
    case ACTION.CHECK_FACE_TERMINAL_RETURN:
      console.log('CHECK_FACE_TERMINAL_RETURN', payload);
      return {
        ...state,
        checkExternalDevice: payload,
      };
    //////// MILESTONE /////////////
    case ACTION.START_SESSION_STREAM_MILESTONE:
      return {
        ...state,
        sessionStreamMilestones: [payload],
      };
    case ACTION.UPDATE_CANDIDATE_WEB_MILESTONE:
      return {
        ...state,
        updateCandidateWebMilestoneReturn: payload,
      };
    case ACTION.UPDATE_CANDIDATES_MILESTONE:
      return {
        ...state,
        updateCandidateMilestoneReturn: payload,
      };
    //////// MILESTONE /////////////

    default:
      return state;
  }
};

export default composeReducers(appReducer, liveReducer, recoveryReducer);
